import {createStateMaker} from '@shared/helpers/object'

import {APIStatus} from '@web/core/constants'

import {ProductDetailState} from '../interfaces'

export const getInitialState = (): ProductDetailState => {
    return {
        products: [],
        productBundle: {},
        assignments: {
            reloadCount: 5,
            apiStatus: APIStatus.IDLE,
            value: {},
        },
    }
}

export {getProducts} from './product'

export const makeMock = createStateMaker<ProductDetailState>(getInitialState)
